import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'

import { ReactComponent as IconHamburger } from 'assets/icons/IconHamburger.svg'
import { ReactComponent as IconUser } from 'assets/icons/IconUser.svg'

import LinkButton from 'components/LinkButton'
import Loader from 'components/Loader'

import { logOutAndRedirect } from 'utils/auth'
import { signOut } from 'store/Auth/actions'
import { getCurrentUserEmail } from 'store/Auth/selector'

export class Sidebar extends Component {
  static propTypes = {
    toggleSidebarActive: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    userEmail: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    signOut: PropTypes.func.isRequired,
    isFullNavbar: PropTypes.bool,
  }

  state = {
    isLoading: false,
  }

  handleLogOut = () => {
    const { signOut, toggleSidebarActive } = this.props
    signOut()
    toggleSidebarActive()
    this.setState({
      isLoading: true,
    })
    logOutAndRedirect()
  }

  render() {
    const { title, userEmail, toggleSidebarActive, isOpen, isFullNavbar } = this.props

    const { isLoading } = this.state

    return (
      <>
        {isLoading ? (
          <Loader />
        ) : (
          <section className={cn('sidebar', { '-open': isOpen }, { '-full-navbar': isFullNavbar })}>
            <div className="sidebar__wrapper">
              <header className="sidebar__header">
                <h3 className="sidebar__title">{title}</h3>
                <button className="sidebar__menu" onClick={toggleSidebarActive} type="button">
                  <IconHamburger className="sidebar__menu-icon" />
                </button>
              </header>
              <div className="sidebar__separator" />
              <nav className="sidebar__navigation">
                <NavLink
                  activeClassName="-active"
                  className="sidebar__item"
                  onClick={toggleSidebarActive}
                  to="/zendesk"
                >
                  ZenDesk
                </NavLink>
              </nav>
              <div className="sidebar__separator" />
              <div className="sidebar__user">
                <div className="sidebar__avatar">
                  <IconUser className="sidebar__icon" />
                </div>
                <div>
                  <div className="sidebar__signed-info">{userEmail}</div>
                  <LinkButton onClick={this.handleLogOut} title="Logout" />
                </div>
              </div>
            </div>
            <div className="sidebar__overlay" onClick={toggleSidebarActive} />
          </section>
        )}
      </>
    )
  }
}

const mapStateToProps = state => ({
  userEmail: getCurrentUserEmail(state),
})

const mapDispatchToProps = {
  signOut,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar)
